import React, { Component } from "react";
import Button from "components/Common/Button";
import Notification from "components/Common/Notification";
import PropTypes from "prop-types";
import { Record } from "immutable";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { resetNotificationError as ResetErrorNotificationAction } from "../../actions";

class OauthForm extends Component {
  authCode = React.createRef();

  /**
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCloseNotification = this.handleCloseNotification.bind(this);
  }

  /**
   * refocus when component updates
   */
  componentDidMount() {
    if (this.authCode) {
      this.authCode.current.focus();
    }
  }

  /**
   * @param {Event} event
   */
  handleSubmit(event) {
    const { checkTFA } = this.props;

    event.preventDefault();

    checkTFA();
  }

  /**
   */
  handleCloseNotification() {
    const { resetNotificationError } = this.props;
    resetNotificationError();
  }

  /**
   * @returns {ReactElement}
   */
  render() {
    const {
      changeTFA, TFA, session, resetOAuthRequirements
    } = this.props;

    const { errorMessage } = session;
    const hasError = session.hasAuthenticationError;

    return (
      <form className="g-form__block Login__block" onSubmit={this.handleSubmit}>
        <div className="Login__page-header">
          <h1>Enter Authentication Code</h1>
          <p>
            An authentication code was just sent to your phone number via SMS.
            Enter the code below to verify your identity.
          </p>

          {hasError && (
            <Notification
              notificationType="error"
              description={errorMessage}
              onClose={this.handleCloseNotification}
              customClassName="Login__notification"
            />
          )}
        </div>
        <label
          className="g-input__label"
          htmlFor="Login__authentication-code"
        >
          Authentication Code
        </label>
        <input
          className="Login__input g-view g-input"
          value={TFA}
          type="text"
          placeholder="1234567"
          onChange={changeTFA}
          autoComplete="off"
          ref={this.authCode}
          id="Login__authentication-code"
          onKeyDown={this.handleKeyPress}
        />

        <div className="Login__button-container">
          <Button
            onClick={this.handleSubmit}
            customClassName="Login__button-container__button"
            title="Submit"
            text="Submit"
            isLoading={session.isAuthenticating}
            disabled={session.isAuthenticating}
          />
          <Button
            onClick={resetOAuthRequirements}
            text="Back"
            title="Back"
            customClassName="Login__button-container__back"
            light
          />
        </div>
      </form>
    );
  }
}


OauthForm.propTypes = {
  changeTFA: PropTypes.func.isRequired,
  checkTFA: PropTypes.func.isRequired,
  resetOAuthRequirements: PropTypes.func.isRequired,
  session: PropTypes.instanceOf(Record).isRequired,
  TFA: PropTypes.string.isRequired,
  resetNotificationError: PropTypes.func.isRequired
};

/**
 * @param {Function} dispatch
 * @returns {Object}
 */
function mapDispatch(dispatch) {
  return {
    resetNotificationError: bindActionCreators(ResetErrorNotificationAction, dispatch)
  };
}

const Connector = connect(null, mapDispatch)(OauthForm);

export default Connector;
